import React from 'react'
import cookie from 'react-cookie'
import { browserHistory } from 'react-router'
import CSSModules from 'react-css-modules'
import styles from './loader.css'


const Loader = ({title, logout, toSignup, taskBack}) => (

    <div className={styles.contentLoader}>
      <div className={styles.contentLoaderItem}>
        <div className={styles.contentLoaderTitleH30}></div>
        <div className={styles.contentLoaderContentH80}></div>
        <div className={styles.contentLoaderContentH70}></div>
        <div className={styles.contentLoaderContentH40}></div>
        <div className={styles.contentLoaderBtnH30}></div>
      </div>
    </div>
)

export default CSSModules(Loader, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/Loader.js